module.exports = __webpack_public_path__ + "static/media/wawawawa.6c171790.mp3";